import { Controller, FieldValues } from "react-hook-form";
import { FormSelect } from "../../FormSelect";
import { SharedControllerProps } from "../types";

interface SelectProps<
  T extends FieldValues = FieldValues,
> extends SharedControllerProps<T> {
  children: React.ReactNode;
  id: string;
}

const Select = <T extends FieldValues = FieldValues>({
  autoFocus,
  control,
  children,
  name,
  rules,
  id,
  label,
  disabled = false,
}: SelectProps<T>) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
      <FormSelect
        label={label}
        id={id}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        autoFocus={autoFocus}
        error={error?.message}
        isDisabled={disabled}
      >
        {children}
      </FormSelect>
    )}
  />
);

export default Select;
